// generated by the plop

import { CodeStatusModel } from '../../symbols';

export interface CodeStatusStateModel {
  codeStatusList: CodeStatusModel[];
}

export const CODE_STATUS_STATE_DEFAULT: CodeStatusStateModel = {
  codeStatusList: []
};
